export enum PaymentProviderType {
    STRIPE = 'STRIPE',
    BANKART = 'BANKART',
}
